module.exports = __webpack_public_path__ + "img/96.1419e3f1.jpg";